import { ListagemConteudoEletronicoComponent } from "./../listagem-conteudo-eletronico/listagem-conteudo-eletronico.component";
import { element } from "protractor";
import { ConteudoEletronicoService } from "./../../../service/caixa/conteudo-eletronico.service";
import { ConteudoEletronicoModel } from "./../../../model/caixa/conteudoeletronico.model";
import { DocumentListComponent } from "@alfresco/adf-content-services";
import { DialogConfirmComponent } from "./../../dialog/dialog-confirm/dialog-confirm.component";
import { MatDialog } from "@angular/material/dialog";
import {
  MatSnackBar,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
} from "@angular/material/snack-bar";
import { MatTableDataSource, MatPaginator, MatSort } from "@angular/material";
import { ConteudoService } from "./../../../service/caixa/conteudo.service";
import { ConteudoModel } from "./../../../model/caixa/conteudo.model";
import { FormGroup, FormBuilder, Validators } from "@angular/forms";
import { TipoConteudoModel } from "./../../../model/caixa/tipoconteudo.model";
import { TipoConteudoService } from "./../../../service/caixa/tipo-conteudo.service";
import { CaixaModel } from "./../../../model/caixa/caixa.model";
import { CaixaService } from "./../../../service/caixa/caixa.service";
import { Router, ActivatedRoute } from "@angular/router";
import { AuthenticationService } from "@alfresco/adf-core";
import { Component, OnInit, ViewChild } from "@angular/core";
import * as CryptoJS from "crypto-js";
import { ConfigurarPastaServiceService } from "app/configurar-pasta-service.service";

import { FormsModule } from "@angular/forms";
import { ProjetosInfoComponent } from "app/components/dialog/projetosinfo/projetosinfo.component";
interface Destinacao {
  value: string;
  label: string;
}

interface Etapas {
  value: string;
  label: string;
}

@Component({
  selector: "app-adicionar-conteudo",
  templateUrl: "./adicionar-conteudo.component.html",
  styleUrls: ["./adicionar-conteudo.component.scss"],
})
export class AdicionarConteudoComponent implements OnInit {
  camposExtras: any[] = [];

  camposOrdenados: any[] = [];
  public loading = false;
  public caixaId;
  public deData;
  public caixa = {} as CaixaModel;
  public tipoConteudos: any[];
  public conteudo = {} as ConteudoModel;
  public conteudoLista = {} as ConteudoModel;
  conteudoForm: FormGroup;
  submit = false;
  adicionarConteudo = false;
  listarConteudo = true;
  adicionarConteudoEletronico = false;
  listarConteudoEletronico = false;

  displayedColumns = [
    "rgItem",
    "tipoConteudo",
    "descricaoConteudo",
    "dataInicial",
    "dataFinal",
    "numDocIni",
    "numDocFin",
    "origem",
    "idDoObjetoDocumento",
    "acoes",
  ];

  destinacaoFinal: Destinacao[] = [
    { value: "ELIMINACAO", label: "Eliminação" },
    { value: "GUARDA PERMANENTE", label: "Guarda Permanente" },
  ];

  etapaDocumental: Etapas[] = [
    { value: "INDEXADO", label: "Indexado" },
    { value: "IMAGENS DISPONIVEIS", label: "Imagens Disponíveis" },
    { value: "ASSINADO", label: "Assinado" },
    { value: "CONCLUIDO", label: "concluído" },
  ];
  displayedColumnsEletronico = ["nome", "excluir"];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginatorEletronico: MatPaginator;
  @ViewChild(MatSort) sortEletronico: MatSort;
  conteudosAny: any[] = [];
  dataSource = new MatTableDataSource<any[]>([]);
  dataSourceEletronico = new MatTableDataSource<ConteudoEletronicoModel>([]);
  horizontalPosition: MatSnackBarHorizontalPosition = "right";
  verticalPosition: MatSnackBarVerticalPosition = "top";
  @ViewChild(DocumentListComponent)
  public statusDaCaixa;
  documentList: DocumentListComponent;
  showViewer: Boolean = false;
  nodeId: String = null;
  filesSelected: any[] = [];
  buttonIncluir = false;
  eletronicos: any[] = [];
  currentFolderId = "-my-";
  nomeColuna = "name";
  root = "Meus arquivos";
  rootId = "-my-";
  apenasLeitura = false;
  tiposDocumentais: any[];
  propriedadesSelecionadas: any[] = [];
  valoresPropriedades: any = {};
  projetos: any[] = [];
  projetoSelecionado: any = null;
  caixaAberta;
  caixaFechada;

  // serieDocumental: any[] = [];

  constructor(
    private authService: AuthenticationService,
    private fb: FormBuilder,
    private service: ConfigurarPastaServiceService,
    private router: Router,
    private route: ActivatedRoute,
    private caixaService: CaixaService,
    private _snackBar: MatSnackBar,
    private tipoConteudoService: TipoConteudoService,
    private conteudoService: ConteudoService,
    private dialog: MatDialog,
    private conteudoEletronicoService: ConteudoEletronicoService
  ) {
    this.route.params.subscribe((params) => (this.caixaId = params["id"]));
    this.deData = CryptoJS.AES.decrypt(
      decodeURIComponent(this.caixaId),
      "pcdoc"
    );
    this.caixaId = JSON.parse(this.deData.toString(CryptoJS.enc.Utf8));
  }

  ngOnInit() {
    this.loading = true;
    this.conteudoForm = this.fb.group({
      rgItem: [""],
      descricaoConteudo: ["", Validators.required],
      origem: [""],
      dataInicial: [""],
      dataFinal: [""],
      numeroDocumentos: [""],
      tipoConteudo: [null],
      nodeDicionario: [null],
      projetoId: [null],
      caixa: [null],
      numDocInicial: [""],
      numDocFinal: [""],
      // estadoConservacao: [""],
      // serieDocumental: [""],
      arquivistico: [false],
      caixaOrigem: [""],
      destinacaoFinal: [null],
      etapaDocumental: [null],
      comentario: [""],
    });
    this.getProjetosPRODESPLocal();
    // this.listarClassificacoesPRODESP();

    // this.getProjetosPRODESP();
    this.getCaixa(this.caixaId);
    //this.getTipoConteudo();
    this.getConteudos(this.caixaId);
    // this.getTokenPRODESP();
  }

  // ...existing code...

  setDestinacaoFinal(valor: string) {
    const campoDestinacao = [
      ...this.camposOrdenados,
      ...this.camposExtras,
    ].find(
      (campo) =>
        campo.title && campo.title.trim().toLowerCase() === "destinação final"
    );
    if (campoDestinacao) {
      this.valoresPropriedades[campoDestinacao.name] = valor;

      setTimeout(() => {
        const element = document.getElementById(
          "prop_" + campoDestinacao.id
        ) as HTMLInputElement;
        if (element) {
          element.value = valor;
        }
      }, 0);
    }
  }
  setEtapaDocumental(valor: string) {
    const campoEtapa = [...this.camposOrdenados, ...this.camposExtras].find(
      (campo) =>
        campo.title && campo.title.trim().toLowerCase() === "etapa documental"
    );
    if (campoEtapa) {
      this.valoresPropriedades[campoEtapa.name] = valor;

      setTimeout(() => {
        const element = document.getElementById(
          "prop_" + campoEtapa.id
        ) as HTMLInputElement;
        if (element) {
          element.value = valor;
        }
      }, 0);
    }
  }

  fecharCaixa() {
    this.loading = true;
    this.caixaService.fecharCaixa(this.caixaId).subscribe(
      (data) => {
        this.loading = false;
        this.openSnackBarSuccess("Caixa fechada com sucesso !");
        this.getCaixa(this.caixaId);
        this.router.navigate(["/caixas"]);
      },
      (error) => {
        this.loading = false;
        console.error(error);
      }
    );
  }

  fecharCaixaDialog() {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {
        name: "Deseja fechar esta caixa ? Obs: Isso impossibilitará de incluir mais itens na caixa.",
        from: "adicionar-conteudo.component.ts",
      },
    });

    dialogRef.afterClosed().subscribe((confirmed: any) => {
      if (confirmed.apagar === true) {
        this.fecharCaixa();
        this.imprimirRelatorio(this.caixa.id);
      }
    });
  }

  imprimirRelatorio(caixaId: any) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {
        name: "Deseja imprimir o relatório desta caixa ?",
        from: "adicionar-conteudo.component.ts",
      },
    });

    dialogRef.afterClosed().subscribe((confirmed: any) => {
      if (confirmed.apagar === true) {
        this.relatorioCaixa(caixaId);
      }
    });
  }

  relatorioCaixa(caixaId) {
    const caixaIdRecebido = encodeURIComponent(
      CryptoJS.AES.encrypt(JSON.stringify(caixaId), "pcdoc").toString()
    );
    window.open(
      `relatorio-caixa/${caixaIdRecebido}`,
      "_blank",
      "location=yes,scrollbars=yes,status=yes"
    ); // Open new window
  }

  abrirCaixaDialog() {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {
        name: "Deseja abrir esta caixa ?",
        from: "adicionar-conteudo.component.ts",
      },
    });

    dialogRef.afterClosed().subscribe((confirmed: any) => {
      if (confirmed.apagar === true) {
        this.abrirCaixa();
      }
    });
  }

  abrirCaixa() {
    this.loading = true;
    this.caixaService.abrirCaixa(this.caixaId).subscribe(
      (data) => {
        this.loading = false;
        this.openSnackBarSuccess("Caixa aberta com sucesso !");
        this.getCaixa(this.caixaId);
      },
      (error) => {
        this.loading = false;
        console.error(error);
      }
    );
  }

  onNodeDblClicked(e) {
    this.currentFolderId = e.detail.node.entry.guid;
    if (e.detail.node.entry.guid !== null) {
      this.nomeColuna = "name";
      this.currentFolderId = e.detail.node.entry.guid;
    } else {
      this.nomeColuna = "title";
      this.currentFolderId = e.detail.node.entry.guid;
    }
  }

  getNodeClienteArea(clienteId, areaId) {
    this.service.getNodeClienteArea(clienteId, areaId).subscribe(
      (data) => {
        // console.log(data);
        console.log("tipos documentais:", data);
        if (data.length === 0) {
          this.openSnackBarError("Nenhum Tipo Documental associado !");
          this.tiposDocumentais = null;
          this.loading = false;
        } else {
          // this.dataSource = new MatTableDataSource(data);
          // this.dataSource.paginator = this.paginator;
          // this.paginator._pageIndex = 0;
          // this.dataSource.sort = this.sort;
          this.tiposDocumentais = data;
          // console.log(this.tiposDocumentais);
          this.tipoConteudos = [...this.tiposDocumentais, ...this.projetos];

          this.setTypeOnInit();
          this.loading = false;
        }
      },
      (err) => {
        console.error(err);
        this.loading = false;
      }
    );
  }

  exibirConteudoEletronico(element) {
    const dialogRef = this.dialog.open(ListagemConteudoEletronicoComponent, {
      width: "100%",
      data: {
        conteudoId: element.id,
        descricaoConteudo: element.descricaoConteudo,
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(`The dialog was closed - ${result}`);
      // console.log(result);
    });
  }

  goMeusSites() {
    this.nomeColuna = "title";
    this.root = "Meus Sites";
    this.rootId = "-mysites-";
    this.currentFolderId = "-mysites-";
  }

  goMeusArquivos() {
    this.nomeColuna = "name";
    this.root = "Arquivos Pessoais";
    this.rootId = "-my-";
    this.currentFolderId = "-my-";
  }

  eventTeste(e) {
    if (e.name === "Sites") {
      e.id = "-mysites-";
      this.nomeColuna = "title";
    } else if (e.name === "User Homes") {
      e.id = "-my-";
    } else if (e.name === "Meus Sites") {
      this.nomeColuna = "title";
    }
  }

  deleteConteudo(conteudoId: number) {
    const dialogRef = this.dialog.open(DialogConfirmComponent, {
      data: {
        name: "Deseja apagar este conteúdo ?",
        from: "adicionar-conteudo.component.ts",
      },
    });
    // const snack = this.snackBar.open('Snack bar open before dialog');

    dialogRef.afterClosed().subscribe((confirmed: any) => {
      if (confirmed.apagar === true) {
        this.apagarItem(this.caixaId, conteudoId);
      }
    });
  }

  deleteConteudoEletronico(conteudoEleId: number) {
    const dialogRefEle = this.dialog.open(DialogConfirmComponent, {
      data: {
        name: "Deseja desvincular o arquivo selecionado ?",
        from: "adicionar-conteudo.component.ts",
      },
    });

    dialogRefEle.afterClosed().subscribe((confirmed: any) => {
      if (confirmed.apagar === true) {
        this.apagarContrueoELetronico(conteudoEleId);
      }
    });
  }

  apagarContrueoELetronico(conteudoEleId: number) {
    this.loading = true;
    this.conteudoEletronicoService.deleteConteudoEle(conteudoEleId).subscribe(
      () => {
        this.loading = false;
        this.openSnackBarSuccess("Arquivo desviculado com sucesso !");
        this.listarConteudos(this.conteudoLista.id);
      },
      (err) => {
        this.loading = false;
        this.openSnackBarError("Erro ao tentar desvincular arquivo !");
        console.error(err);
      }
    );
  }

  showPreview(event) {
    this.showViewer = false;
    if (event.value.entry.isFile) {
      this.nodeId = event.value.entry.id;
      this.showViewer = true;
    }
  }

  selectedDocumentList(event: any) {
    event.forEach((element) => {
      if (element.entry.isFile) {
        const found = this.filesSelected.find(
          (el) => el.nodeId === element.entry.id
        );
        if (found != undefined) {
          return this.openSnackBarError(
            "Não pode adicionar arquivos duplicados !"
          );
        } else {
          this.filesSelected.push({
            nome: element.entry.name,
            nodeId: element.entry.id,
          });
          this.buttonIncluir = true;
        }
      } else {
        this.openSnackBarError("Não é permitido incluir pasta !");
      }
    });
  }

  incluirEletronico(conteudoId: number) {
    this.loading = true;
    this.conteudoEletronicoService
      .adicionarConteudoEletronico(this.filesSelected, conteudoId)
      .subscribe(
        (data) => {
          this.loading = false;
          this.openSnackBarSuccess(
            "Documentos eletrônicos adicionados com sucesso !"
          );
          this.adicionarConteudoEletronico = false;
          this.listarConteudoEletronico = true;
          this.listarConteudos(conteudoId);
          this.filesSelected = [];
          this.buttonIncluir = false;
        },
        (err) => {
          this.loading = false;
          if (err.error.message === "Conteúdo eletrônico já adicionado !") {
            this.openSnackBarError(err.error.message);
          } else {
            this.openSnackBarError("Erro ao adicionar os documentos !");
          }
          console.error(err);
        }
      );
  }

  cancelarInclusao() {
    this.listarConteudoEletronico = false;
    this.listarConteudo = true;
  }

  incluirConteudoEletronico() {
    this.listarConteudoEletronico = false;
    this.adicionarConteudoEletronico = true;
  }

  listarConteudos(conteudoId: number) {
    this.conteudoEletronicoService.listarConteudosEle(conteudoId).subscribe(
      (data) => {
        this.eletronicos = data;
        this.dataSourceEletronico = new MatTableDataSource(this.eletronicos);
        this.dataSourceEletronico.paginator = this.paginatorEletronico;
        this.dataSourceEletronico.sort = this.sortEletronico;
      },
      (err) => {
        console.error(err);
      }
    );
  }

  excluirDoc(file) {
    const foundIndex = this.filesSelected.findIndex(
      (x) => x.nodeId === file.nodeId
    );
    this.filesSelected.splice(foundIndex, 1);
    if (this.filesSelected.length === 0) {
      this.buttonIncluir = false;
    }
  }

  addConteudo() {
    this.conteudo = new ConteudoModel();
    this.listarConteudo = false;
    this.adicionarConteudo = true;
    this.setTypeOnInit();
    // this.isRgAutomatico();
  }

  reset() {
    // this.submit = false;
    // this.conteudoForm.reset();
    // this.conteudo.id = undefined;
    this.listarConteudo = true;
    this.adicionarConteudo = false;
    // // this.submit = false;
    // // this.conteudoForm.reset();
    // // this.conteudo.id = undefined;
  }

  goListagem() {
    this.adicionarConteudo = false;
    this.listarConteudo = true;
    this.conteudoForm.reset();
    this.submit = false;
    this.conteudo.id = undefined;
  }

  goListagem2() {
    this.adicionarConteudoEletronico = false;
    this.listarConteudo = true;
    this.conteudoForm.reset();
    this.submit = false;
    this.conteudo.id = undefined;
  }

  getConteudos(caixaId: number) {
    this.conteudoService.listaItens(caixaId).subscribe(
      (data) => {
        // Enriquecer cada item com o projeto, se necessário
        this.conteudosAny = data.map((item) => {
          if (!item.nodeDicionario && item.projetoId) {
            const projeto = this.projetos.find((p) => p.id === item.projetoId);
            return { ...item, tipoConteudo: projeto };
          }
          return item;
        });
        this.dataSource = new MatTableDataSource(this.conteudosAny);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.loading = false;
        console.log("dados da tabela", this.dataSource.data);
      },
      (err) => {
        console.error(err);
      }
    );
  }

  getCaixa(idCaixa: Number) {
    this.caixaService.getCaixaUnica(idCaixa).subscribe(
      (data) => {
        this.caixa = data;
        // console.log(this.caixa);
        if (data.statusCaixa === "EM_PROCESSO_DE_CADASTRO") {
          this.statusDaCaixa = true;
          this.caixaAberta = true;
          this.caixaFechada = false;
        } else {
          this.statusDaCaixa = false;
          this.caixaFechada = true;
          this.caixaAberta = false;
        }
        // console.log(this.statusDaCaixa);
        this.getNodeClienteArea(this.caixa.cliente.id, this.caixa.area.id);
        this.conteudoForm.get("caixa").setValue(this.caixa);
      },
      (err) => {
        console.error(err);
      }
    );
  }

  isRgAutomatico() {
    if (this.caixa.cliente.gerarRG) {
      this.caixaService.gerarRGConteudo(this.caixa.id).subscribe((data) => {
        const resultData = data;
        if (resultData.cod == 200) {
          this.conteudoForm.get("rgItem").setValue(resultData.result);
        } else {
          this.conteudoForm.get("rgItem").setValue("");
        }
      });
    }
  }

  getTipoConteudo() {
    this.tipoConteudoService.getTiposRegistros().subscribe(
      (data) => {
        this.tipoConteudos = data;
      },
      (err) => {
        console.error(err);
      }
    );
  }

  onSubmit() {
    this.submit = true;
  }

  adicionarItem() {
    this.loading = true;

    const formValues = this.conteudoForm.value;
    if (
      formValues.projetoId &&
      this.camposOrdenados.length === 0 &&
      this.camposExtras.length === 0
    ) {
      this.openSnackBarError("Aguarde o carregamento dos campos do projeto!");
      this.loading = false;
      return;
    }
    this.capturarValoresPropriedades();

    let camposParaProcessar = [];
    if (formValues.projetoId) {
      camposParaProcessar = [...this.camposOrdenados, ...this.camposExtras];
    } else {
      camposParaProcessar = this.propriedadesSelecionadas;
    }

    const propriedadeValor = camposParaProcessar
      .filter((prop) => this.valoresPropriedades[prop.name])
      .map((prop) => ({
        campoId: prop.id,
        campoNome: prop.campoNome,
        chave: prop.campoNome,
        valor: this.valoresPropriedades[prop.name] || "",
      }));

    const conteudo = {
      ...formValues,
      propriedadeValor: propriedadeValor,
    };

    console.log("payload enviado:", conteudo);
    this.loading = false;
    this.conteudoService.incluirItens(this.caixaId, conteudo).subscribe(
      (data) => {
        this.loading = false;
        this.openSnackBarSuccess(`Conteúdo adicionado com sucesso !`);
        this.getConteudos(this.caixaId);
        this.conteudoForm.reset();
        this.submit = false;
        this.adicionarConteudo = false;
        this.listarConteudo = true;
        this.getCaixa(this.caixaId);
      },
      (err) => {
        this.loading = false;
        console.error(err);
        if (err.error.message === "Conteúdo já criado com este RG de Item !") {
          this.openSnackBarError(err.error.message);
        } else {
          this.openSnackBarError("Preencha todos os campos obrigatórios !");
        }
      }
    );
  }

  apagarItem(caixaId: number, conteudoId: number) {
    this.loading = true;
    this.conteudoService.apagarItem(caixaId, conteudoId).subscribe(
      () => {
        this.loading = false;
        this.openSnackBarSuccess("Conteúdo excluído com sucesso !");
        this.getConteudos(this.caixaId);
        this.getCaixa(this.caixaId);
      },
      (err) => {
        this.loading = false;
        console.error(err);
        this.openSnackBarError("Erro ao tentar excluir este conteúdo");
      }
    );
  }

  getDados(dados) {
    console.log("dados", dados);
    this.conteudo = { ...dados };
    this.listarConteudo = false;
    this.adicionarConteudo = true;

    // Buscar o projeto pelo projetoId
    if (dados.projetoId) {
      // É um projeto PRODESP
      const projetoEncontrado = this.projetos.find(
        (p) => p.id === dados.projetoId
      );
      if (projetoEncontrado) {
        this.conteudoForm.get("tipoConteudo").setValue(projetoEncontrado);
        this.conteudoForm.get("projetoId").setValue(projetoEncontrado.id);
        this.conteudoForm.get("nodeDicionario").setValue(null);

        // Buscar campos do projeto e depois preencher com valores salvos
        this.buscarCamposProjetoParaEdicao(
          dados.projetoId,
          dados.propriedadeValor
        );
      }
    } else if (dados.nodeDicionario) {
      // É um tipo documental
      const tipoEncontrado = this.tiposDocumentais.find(
        (t) => t.id === dados.nodeDicionario.id
      );
      if (tipoEncontrado) {
        this.conteudoForm.get("tipoConteudo").setValue(tipoEncontrado);
        this.conteudoForm.get("nodeDicionario").setValue(tipoEncontrado);
        this.conteudoForm.get("projetoId").setValue(null);

        // Carregar propriedades do tipo documental e preencher valores
        this.carregarPropriedadesTipoDocumental(tipoEncontrado);
        this.preencherValoresPropriedades(dados.propriedadeValor);
      }
    }

    // Preencher outros campos do formulário
    this.conteudoForm.patchValue({
      rgItem: dados.rgItem,
      descricaoConteudo: dados.descricaoConteudo,
      origem: dados.origem,
      dataInicial: dados.dataInicial,
      dataFinal: dados.dataFinal,
      numDocInicial: dados.numDocInicial,
      numDocFinal: dados.numDocFinal,
      // estadoConservacao: dados.estadoConservacao,
      // serieDocumental: dados.serieDocumental,
      arquivistico: dados.arquivistico || false,
      caixaOrigem: dados.caixaOrigem,
      destinacaoFinal: dados.destinacaoFinal,
      etapaDocumental: dados.etapaDocumental,
      caixa: dados.caixa,
      comentario: dados.comentario,
    });
  }

  compararNodeEditConteudo(obj1, obj2) {
    return obj1 && obj2
      ? obj1.title === obj2.title && obj1.id === obj2.id
      : obj1 === obj2;
  }

  addConteudoEletronico(dados) {
    this.conteudoLista = { ...dados };
    this.listarConteudo = false;
    this.listarConteudos(dados.id);
    this.listarConteudoEletronico = true;
  }

  addOrEditConteudo(conteudo: ConteudoModel) {
    if (this.conteudo.id !== undefined) {
      this.editarItem(conteudo);
    } else {
      this.adicionarItem();
    }
  }

  editarItem(conteudo: ConteudoModel) {
    this.loading = true;
    this.capturarValoresPropriedades();
    const propriedadeValor = this.propriedadesSelecionadas
      .filter((prop) => this.valoresPropriedades[prop.name])
      .map((prop) => ({
        campoId: prop.id,
        campoNome: prop.campoNome,
        chave: prop.campoNome,
        valor: this.valoresPropriedades[prop.name] || "",
        conteudoId: this.conteudo.id,
      }));

    // Pegar valores do formulário
    const formValues = this.conteudoForm.value;

    // Montar o objeto completo para edição
    const conteudoParaEdicao = {
      ...formValues,
      id: this.conteudo.id, // Incluir o ID para identificar qual conteúdo editar
      propriedadeValor: propriedadeValor,
    };

    // return;
    this.conteudoService.editarItem(conteudoParaEdicao).subscribe(
      () => {
        this.loading = false;
        this.openSnackBarSuccess("Conteúdo editado com sucesso !");
        this.adicionarConteudo = false;
        this.listarConteudo = true;
        this.submit = false;
        this.conteudoForm.reset();
        this.conteudo = undefined;
        this.propriedadesSelecionadas = [];
        this.valoresPropriedades = {};
        this.getConteudos(this.caixaId);
        this.getCaixa(this.caixaId);
      },
      (err) => {
        this.loading = false;
        console.error(err);
        if (err.error.message === "Conteúdo já criado com este RG de Item !") {
          this.openSnackBarError(err.error.message);
        } else {
          this.openSnackBarError("Preencha todos os campos obrigatórios !");
        }
      }
    );
  }

  compararEditConteudo(obj1, obj2) {
    return obj1 && obj2
      ? obj1.descricao === obj2.descricao && obj1.id === obj2.id
      : obj1 === obj2;
  }

  // ALERTAS
  // SnackBares
  openSnackBarSuccess(message: string) {
    this._snackBar.open(message, "", {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 4000,
      panelClass: ["success-snackbar"],
    });
  }

  openSnackBarError(message: string) {
    this._snackBar.open(message, "", {
      horizontalPosition: this.horizontalPosition,
      verticalPosition: this.verticalPosition,
      duration: 3000,
      panelClass: ["error-snackbar"],
    });
  }

  changeValue(event) {
    if (event.currentTarget.checked) {
      this.caixaService
        .changeRGAutomatico(this.caixaId, event.currentTarget.checked)
        .subscribe((data) => {
          const resultData = data;
          if (resultData.cod == 200) {
            this.conteudoForm.get("rgItem").setValue(resultData.result);
          } else {
            this.conteudoForm.get("rgItem").setValue("");
          }
        });
    } else {
      this.caixaService
        .changeRGAutomatico(this.caixaId, event.currentTarget.checked)
        .subscribe((data) => {
          const resultData = data;
          if (resultData.cod == 200) {
            this.conteudoForm.get("rgItem").setValue("");
          } else {
            this.conteudoForm.get("rgItem").setValue("");
          }
        });
    }
  }

  onDateInput(event) {
    const value = event.target.value;
    if (value.length > 10) {
      event.target.value = value.substring(1);
      this.conteudo.dataInicial = event.target.value;
    }
  }

  setType(event: any) {
    const selectedValue = event.value;

    // Se for vazio, limpar tudo
    if (!selectedValue) {
      this.conteudoForm.get("tipoConteudo").setValue(null);
      this.conteudoForm.get("projetoId").setValue(null);
      this.conteudoForm.get("nodeDicionario").setValue(null);
      this.propriedadesSelecionadas = [];
      this.valoresPropriedades = {};
      localStorage.removeItem("RM_TYPE_CACHE");
      return;
    }

    const jsonSave = selectedValue;

    console.log("Tipo encontrado:", jsonSave);

    // Salvar no cache
    localStorage.setItem("RM_TYPE_CACHE", JSON.stringify(jsonSave));

    // Limpar valores anteriores
    this.valoresPropriedades = {};
    this.propriedadesSelecionadas = [];

    // O setValue já foi feito pelo Angular com ngValue, mas vamos garantir
    this.conteudoForm.get("tipoConteudo").setValue(jsonSave);

    // Verificar se é um projeto PRODESP
    if (jsonSave.isProjeto) {
      console.log("Projeto selecionado:", jsonSave);
      this.conteudoForm.get("projetoId").setValue(jsonSave.id);
      this.conteudoForm.get("nodeDicionario").setValue(null);
      this.buscarCamposProjeto(jsonSave.id);
    } else {
      console.log("Tipo documental selecionado:", jsonSave);
      this.conteudoForm.get("nodeDicionario").setValue(jsonSave);
      this.conteudoForm.get("projetoId").setValue(null);
      this.carregarPropriedadesTipoDocumental(jsonSave);
    }

    console.log("Propriedades selecionadas:", this.propriedadesSelecionadas);
  }

  setTypeOnInit() {
    const typeCache = localStorage.getItem("RM_TYPE_CACHE");
    if (typeCache !== null) {
      const tipoSelecionado = JSON.parse(typeCache);

      // Aguardar que tipoConteudos seja carregado
      if (!this.tipoConteudos || this.tipoConteudos.length === 0) {
        // Se ainda não foi carregado, aguardar um pouco e tentar novamente
        setTimeout(() => this.setTypeOnInit(), 100);
        return;
      }

      this.conteudoForm.get("tipoConteudo").setValue(tipoSelecionado);
      this.conteudo.nodeDicionario = tipoSelecionado;

      if (tipoSelecionado.isProjeto) {
        this.conteudoForm.get("projetoId").setValue(tipoSelecionado.id);
        this.conteudoForm.get("nodeDicionario").setValue(null);
        this.buscarCamposProjeto(tipoSelecionado.id);
      } else {
        this.conteudoForm.get("nodeDicionario").setValue(tipoSelecionado);
        this.conteudoForm.get("projetoId").setValue(null);
        this.carregarPropriedadesTipoDocumental(tipoSelecionado);
      }
    }
  }

  carregarPropriedadesTipoDocumental(tipoDocumental: any) {
    this.propriedadesSelecionadas = [...(tipoDocumental.propriedades || [])];

    // Adicionar propriedades dos aspectos
    if (tipoDocumental.aspectos && tipoDocumental.aspectos.length > 0) {
      tipoDocumental.aspectos.forEach((aspecto) => {
        if (aspecto.propriedades && aspecto.propriedades.length > 0) {
          this.propriedadesSelecionadas.push(...aspecto.propriedades);
        }
      });
    }
  }

  // Método para capturar valores dos campos dinâmicos
  capturarValoresPropriedades() {
    // Para projetos, usar camposOrdenados + camposExtras
    const formValues = this.conteudoForm.value;

    if (formValues.projetoId) {
      // É um projeto - usar camposOrdenados e camposExtras
      const todosCampos = [...this.camposOrdenados, ...this.camposExtras];

      todosCampos.forEach((campo) => {
        const element = document.getElementById(
          "prop_" + campo.id
        ) as HTMLInputElement;
        if (element && element.value) {
          this.valoresPropriedades[campo.name] = element.value;
        }
      });
    } else {
      // É tipo documental - usar propriedadesSelecionadas
      this.propriedadesSelecionadas.forEach((prop) => {
        const element = document.getElementById(
          "prop_" + prop.id
        ) as HTMLInputElement;
        if (element && element.value) {
          this.valoresPropriedades[prop.name] = element.value;
        }
      });
    }

    console.log(
      "Valores das propriedades capturados:",
      this.valoresPropriedades
    );
  }

  // getProjetosPRODESP() {
  //   this.caixaService.getProjetosPRODESP().subscribe((data) => {
  //     // Transformar projetos para ter a mesma estrutura dos tipos documentais
  //     this.projetos = data.map((projeto) => ({
  //       ...projeto,
  //       title: projeto.name, // Adicionar o campo title baseado no name
  //       isProjeto: true, // Flag para identificar que é um projeto
  //     }));
  //     console.log("projetos PRODESP:", this.projetos);
  //   });
  // }

  getTokenPRODESP() {
    this.caixaService.getTokenPRODESP().subscribe(
      (response) => {
        console.log("Token completo:", response);
        console.log("Access token:", response.access_token);
        console.log("Expires in:", response.expires_in);
      },
      (error) => {
        console.error("Erro ao obter token:", error);
      }
    );
  }

  getProjetosPRODESPLocal() {
    this.caixaService.getProjetosPRODESPLocal().subscribe(
      (response) => {
        console.log("projetos PRODESP:", response);
        this.projetos = response.map((projeto) => ({
          ...projeto,
          title: projeto.name,
          isProjeto: true,
        }));
        console.log(this.projetos);
        console.log(this.tipoConteudos);
      },
      (error) => {
        console.error("Erro ao obter token:", error);
      }
    );
  }

  // listarClassificacoesPRODESP() {
  //   this.caixaService.listarClassificacoesPRODESP().subscribe(
  //     (response) => {
  //       console.log("CLASSIFICAÇÕES:", response);
  //       this.serieDocumental = response;
  //     },
  //     (error) => {
  //       console.error("Erro ao obter token:", error);
  //     }
  //   );
  // }

  buscarCamposProjeto(projetoId: number) {
    this.loading = true;
    this.caixaService.getCamposProjeto(projetoId).subscribe(
      (campos) => {
        console.log("Campos do projeto:", campos);

        const ordemPersonalizada = [
          "Série documental",
          "Assunto",
          "Interessado",
          "Número de Volumes",
          "Número Protocolo",
          "Número de Controle do Documento",
          "Data do documento",
          "Data de encerramento",
          "Data da aprovação das contas",
          "Caixa",
          "Prazo de Guarda",
          "Número Código de Barras da Caixa",
          "Etiqueta",
          "Estado de Conservação",
          "Ausência de Folhas",
          "Destinação Final",
          "Formato",
          "Suporte",
          "Localização",
        ];

        const normalizar = (s: string) => {
          if (!s) return "";
          return s
            .toString()
            .normalize("NFD")
            .replace(/[\u0300-\u036f]/g, "")
            .trim()
            .toLowerCase();
        };

        const ordemNormalizada = ordemPersonalizada.map(normalizar);

        const todosCampos = campos.map((campo) => ({
          id: campo.id,
          name: campo.coluna,
          title: campo.nome,
          type: "d:text",
          mandatory: 0,
          readOnly: 0,
          description: campo.descricao || "",
          defaultValue: "",
          campoId: campo.id,
          campoNome: campo.nome,
          chave: campo.nome,
        }));

        this.camposOrdenados = todosCampos
          .filter((c) => ordemNormalizada.includes(normalizar(c.title)))
          .sort(
            (a, b) =>
              ordemNormalizada.indexOf(normalizar(a.title)) -
              ordemNormalizada.indexOf(normalizar(b.title))
          );

        this.camposExtras = todosCampos.filter(
          (c) => !ordemNormalizada.includes(normalizar(c.title))
        );
        this.propriedadesSelecionadas = [
          ...this.camposOrdenados,
          ...this.camposExtras,
        ];
        this.loading = false;
      },
      (error) => {
        console.error("Erro ao buscar campos do projeto:", error);
        this.openSnackBarError("Erro ao carregar campos do projeto!");
        this.camposOrdenados = [];
        this.camposExtras = [];
        this.loading = false;
      }
    );
  }

  compararTipos(obj1: any, obj2: any): boolean {
    if (!obj1 || !obj2) return obj1 === obj2;
    return obj1.id === obj2.id;
  }

  buscarCamposProjetoParaEdicao(projetoId: number, propriedadeValor: any[]) {
    this.loading = true;
    this.caixaService.getCamposProjeto(projetoId).subscribe(
      (campos) => {
        console.log("Campos do projeto para edição:", campos);
        this.propriedadesSelecionadas = campos.map((campo) => ({
          id: campo.id,
          name: campo.coluna,
          title: campo.nome,
          type: "d:text",
          mandatory: 0,
          readOnly: 0,
          description: campo.descricao || "",
          defaultValue: "",
          campoId: campo.id,
          campoNome: campo.nome,
          chave: campo.nome,
        }));

        // Preencher valores após carregar as propriedades
        this.preencherValoresPropriedades(propriedadeValor);
        this.loading = false;
      },
      (error) => {
        console.error("Erro ao buscar campos do projeto:", error);
        this.openSnackBarError("Erro ao carregar campos do projeto!");
        this.propriedadesSelecionadas = [];
        this.loading = false;
      }
    );
  }

  preencherValoresPropriedades(propriedadeValor: any[]) {
    // Limpar valores anteriores
    this.valoresPropriedades = {};

    // Se não há propriedades salvas, não fazer nada
    if (!propriedadeValor || propriedadeValor.length === 0) {
      return;
    }

    // Preencher valores das propriedades que estão salvas no banco
    propriedadeValor.forEach((prop) => {
      // Buscar a propriedade correspondente pelo campoId
      const propriedadeEncontrada = this.propriedadesSelecionadas.find(
        (p) => p.id === prop.campoId || p.campoId === prop.campoId
      );

      if (propriedadeEncontrada) {
        this.valoresPropriedades[propriedadeEncontrada.name] = prop.valor;
      }
    });

    // Aguardar um pouco para que os campos sejam renderizados no DOM
    setTimeout(() => {
      this.preencherCamposNoDom();
    }, 100);
  }

  preencherCamposNoDom() {
    this.propriedadesSelecionadas.forEach((prop) => {
      const element = document.getElementById(
        "prop_" + prop.id
      ) as HTMLInputElement;
      if (element && this.valoresPropriedades[prop.name]) {
        element.value = this.valoresPropriedades[prop.name];
      }
    });
  }
  mostrarInfo(tipoConteudo: any) {
    // Aqui você pode abrir um MatDialog, Snackbar ou apenas um alert

    const dialogRef = this.dialog.open(ProjetosInfoComponent, {
      width: "1000px",
      height: "500px",
      data: tipoConteudo,
    });

    dialogRef.afterClosed().subscribe((confirmed: any) => {
      console.log("fechado");
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/caixa/adicionar-conteudo/adicionar-conteudo.component.ts